var _a, _b;
import { __assign } from "tslib";
import { handleActions } from 'redux-actions';
import { reduxKey } from './constants';
import { searchFailure, searchSuccess, searchTags } from './actions';
import { RequestStatus } from './types';
var reducers = handleActions((_a = {},
    _a[searchTags.toString()] = function (state) { return (__assign(__assign({}, state), { searchRequestStatus: RequestStatus.Processing })); },
    _a[searchSuccess.toString()] = function (state, action) { return (__assign(__assign({}, state), { tagSearchResults: action.payload.tags, searchRequestStatus: RequestStatus.Success })); },
    _a[searchFailure.toString()] = function (state) { return (__assign(__assign({}, state), { tagSearchResults: [], searchRequestStatus: RequestStatus.Failure })); },
    _a), {
    tagSearchResults: [],
    searchRequestStatus: RequestStatus.Success,
});
export default (_b = {}, _b[reduxKey] = reducers, _b);
//# sourceMappingURL=reducer.js.map